module.exports = __webpack_public_path__ + "img/Recco-red.70a8f4fd.png";